import Vue from 'vue'
import { Component, Prop, PropSync, Watch } from 'vue-property-decorator'
import {ModalHeader, ModalContent, ModalFooter,ContentItem,Dropdown} from '@gnb/components/Common'
import PreferenceContentTemplate from '@gnb/templates/PreferenceContentTemplate.vue'
import TabOrder from './TabOrder.vue'
import * as types from '@gnb/store/types'
import { mapActions, mapGetters } from 'vuex'
@Component({
    components:{
        TabOrder,
        ModalHeader,
        ModalContent,
        ModalFooter,
        ContentItem,
        PreferenceContentTemplate,
        Dropdown
    }
    ,computed:{
        ...mapGetters({
            mySetting: types.SETTINGS_MYSETTING_DATA,
        })
    }
    ,methods:{
        ...mapActions({
        saveSetting: types.SETTINGS_MYSETTING_SAVE,
        })
    }
})
export default class ChangeApprovalOrder extends Vue {

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    name:string = this.$t('메인_결재함_순서_변경').toString();
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Object }) settingInfo!: gnb.TA_MYSETTING;
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    saveSetting!: (payload: { data: gnb.TA_MYSETTING, isFirst: boolean }) => Promise<boolean>;
    mySetting!: gnb.CM_MySetting;
    


    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    save(){
        this.$emit('save')
    }

    
}